import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useMobile } from "@rapid/hooks/useMobile";
import { useCoreApp } from "@rapid/contexts/CoreAppContext";
import { DEFAULT_DURATION } from "@rapid/constants/motion";

export const Sidebar = ({ children }: { children: React.ReactNode }) => {
    const { hideSidebar } = useCoreApp();
    const isMobile = useMobile();

    return (
        <motion.div
            className="relative flex h-full w-[340px] flex-shrink-0 flex-col border-l bg-white"
            initial={false}
            animate={{
                ...(isMobile && { height: hideSidebar ? 0 : "auto" }),
                paddingTop: hideSidebar ? 0 : undefined,
                paddingBottom: hideSidebar ? 0 : undefined
            }}
            transition={{
                duration: DEFAULT_DURATION.slower,
                ease: "easeInOut",
                ...(isMobile && { height: { duration: DEFAULT_DURATION.slower } })
            }}
            style={{ overflow: "hidden" }}
        >
            <AnimatePresence mode="wait">
                {!hideSidebar && (
                    <motion.div
                        key="sidebar-content"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: DEFAULT_DURATION.slower, ease: "easeOut" }}
                        className="sidebarBody hideOnMobile"
                    >
                        {children}
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
};
